import { createIconComponent } from '../../factory/create-icon-component';
export const ManageScopeIcon = createIconComponent(
  'ManageScopeIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.0874 5.79897 21.2875 10.7148 21.9182C10.9291 21.9457 11.1456 21.9664 11.364 21.9801"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 2V4"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 12H4"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 12L22 12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 6L19.0004 5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 19L6.00037 18"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 5L6 6"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 12.5555C14 15.8148 10 15.8148 10 12.5555C10 10.4815 11.9999 9 11.9999 9C11.9999 9 14 10.4815 14 12.5555Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.25 15.25L15.9503 17.5497L15.9503 17.5497C15.4118 18.0882 15.1425 18.3575 14.932 18.6657C14.7451 18.9392 14.593 19.2348 14.479 19.5458C14.3506 19.8963 14.288 20.2719 14.1628 21.0231L14 22L14.9769 21.8372C15.7281 21.712 16.1037 21.6494 16.4542 21.521C16.7652 21.407 17.0608 21.2549 17.3343 21.068C17.6425 20.8575 17.9118 20.5882 18.4502 20.0498L18.4503 20.0497L20.75 17.75C21.4404 17.0596 21.4404 15.9404 20.75 15.25C20.0596 14.5596 18.9404 14.5596 18.25 15.25Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
);
